// extracted by mini-css-extract-plugin
export default {"s_table":"detailsTable_s_table__uayPW","s_optional":"detailsTable_s_optional__o040T"};